import ApiService from '@/core/services/api.service'
import { get3MPercentage, formatDate } from '@/core/helpers/util.js'

// action types
export const FETCH_3M = 'fetch3m'
export const FETCH_SUMMARY = 'fetchSummary'
export const FETCH_DISTRICT_SUMMARY = 'fetchDistrictSummary'
export const FETCH_TREND = 'fetchTrend'

// mutation types
export const SET_3M = 'set3M'
export const SET_SUMMARY = 'setSummary'
export const SET_DISTRICT_SUMMARY = 'setDistrictSummary'
export const SET_TREND = 'setTrend'
export const SET_ERROR = 'setError'

const state = {
  errors: null,
  tigaMData: null,
  summaryData: null,
  districtSummaryData: null,
  trendData: null,
}

const getters = {
  // MAP MARKERS
  // mencuciTangan: (state) => (id) => {
  //   if (state.tigaMData) {
  //     const items = state.tigaMData.filter((item) => item.id_provinsi === id)

  //     const results = items.map(function (item) {
  //       return {
  //         lat: `${item.lat}`,
  //         lng: item.lng,
  //         value: item.jumlahcucitangan,
  //         name: item.nama_sekolah,
  //         ref: 'mencuci tangan',
  //       }
  //     })
  //     return results
  //   }
  //   return false
  // },
  mencuciTangan(state) {
    if (state.tigaMData) {
      const results = state.tigaMData.map(function (item) {
        return {
          lat: `${item.lat}`,
          lng: item.lng,
          value: item.jumlahcucitangan,
          name: item.nama_sekolah,
          provinsi: item.provinsi,
          ref: 'mencuci tangan',
        }
      })
      return results
    }
    return false
  },
  memakaiMasker(state) {
    if (state.tigaMData) {
      const results = state.tigaMData.map(function (item) {
        return {
          lat: `${item.lat}`,
          lng: item.lng,
          value: item.jumlahmaskerbenar,
          name: item.nama_sekolah,
          provinsi: item.provinsi,
          ref: 'memakai masker',
        }
      })
      return results
    }
    return false
  },
  menjagaJarak(state) {
    if (state.tigaMData) {
      const results = state.tigaMData.map(function (item) {
        return {
          lat: `${item.lat}`,
          lng: item.lng,
          value: item.jumlahjagajarak,
          name: item.nama_sekolah,
          provinsi: item.provinsi,
          ref: 'menjaga jarak',
        }
      })
      return results
    }
    return false
  },
  getSummary(state) {
    if (state.summaryData) {
      return state.summaryData[0]
    }
    return false
  },

  // DISTRICT SUMMARY
  districtMencuciTangan(state) {
    if (state.districtSummaryData) {
      const results = state.districtSummaryData.map(function (item) {
        return {
          id_kabupaten: item.id_kabupaten,
          kabupaten: item.kabupaten,
          value: get3MPercentage(
            item.capaian_mencuci_tangan,
            item.jumlah_laporan
          ),
          count_report: item.jumlah_laporan,
          ref: 'District mencuci tangan',
        }
      })
      return results
    }
    return false
  },
  districtMemakaiMasker(state) {
    if (state.districtSummaryData) {
      const results = state.districtSummaryData.map(function (item) {
        return {
          id_kabupaten: item.id_kabupaten,
          kabupaten: item.kabupaten,
          value: get3MPercentage(
            item.capaian_memakai_masker,
            item.jumlah_laporan
          ),
          count_report: item.jumlah_laporan,
          ref: 'District memakai masker',
        }
      })
      return results
    }
    return false
  },
  districtMenjagaJarak(state) {
    if (state.districtSummaryData) {
      const results = state.districtSummaryData.map(function (item) {
        return {
          id_kabupaten: item.id_kabupaten,
          kabupaten: item.kabupaten,
          value: get3MPercentage(
            item.capaian_menjaga_jarak,
            item.jumlah_laporan
          ),
          count_report: item.jumlah_laporan,
          ref: 'District menjaga jarak',
        }
      })
      return results
    }
    return false
  },

  // TREND DATA
  getTrend: (state) => (type) => {
    if (state.trendData) {
      const items = state.trendData.map(function (item) {
        return {
          date: formatDate(item.day),
          value: get3MPercentage(item[type], item.count_data),
          count_report: item.count_data,
        }
      })

      return items
    }
    return false
  },
}

const actions = {
  // currently used for markers
  [FETCH_3M](context, params) {
    return new Promise((resolve) => {
      ApiService.post('api/tiga_m/all', params)
        .then(({ data }) => {
          // console.log('Here what post returns', data)
          context.commit(SET_3M, data)
          resolve(data)
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response)
        })
    })
  },

  [FETCH_SUMMARY](context, params) {
    return new Promise((resolve) => {
      ApiService.post('api/tiga_m/summary', params)
        .then(({ data }) => {
          // console.log('Here what post returns', data)
          context.commit(SET_SUMMARY, data)
          resolve(data)
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response)
        })
    })
  },

  [FETCH_DISTRICT_SUMMARY](context, params) {
    return new Promise((resolve) => {
      ApiService.post('api/tiga_m/district_summary', params)
        .then(({ data }) => {
          // console.log('Here what post returns', data)
          context.commit(SET_DISTRICT_SUMMARY, data)
          resolve(data)
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response)
        })
    })
  },

  [FETCH_TREND](context, params) {
    return new Promise((resolve) => {
      ApiService.post('api/tiga_m/trend', params)
        .then(({ data }) => {
          // console.log('Here what post returns', data)
          context.commit(SET_TREND, data)
          resolve(data)
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response)
        })
    })
  },
}

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error
  },
  [SET_3M](state, payload) {
    state.tigaMData = Object.freeze(payload)
    state.errors = null
  },
  [SET_SUMMARY](state, payload) {
    state.summaryData = Object.freeze(payload)
    state.errors = null
  },
  [SET_DISTRICT_SUMMARY](state, payload) {
    state.districtSummaryData = Object.freeze(payload)
    state.errors = null
  },
  [SET_TREND](state, payload) {
    state.trendData = Object.freeze(payload)
    state.errors = null
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
